import {
    Container,
    FormValue,
    useModal,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalSubHeader,
    Spacer,
    Grid,
    Tabs,
    Tab,
    Island,
    FormInput,
    Tag,
    Text,
    useDialog,
    FormLabel,
    FormTags,
    FormCheckbox,
    FormSelect,
    FormToggle,
    Notice,
    FormNotice,
    FormNumber,
    FormTextarea,
    Ellipsis,
    Tbody,
    Thead,
    Tr,
    Th,
    Td,
    TdInput,
    Table,
    Icon,
} from "@holta/ui";
import React from "react";
import styled from "styled-components";
import { useModalProductComponentContext } from "./context";
import { useStore } from "../../hooks/useStore";
import { fns, libTypes } from "@holta/lib";

interface Props {
    children?: React.ReactNode;
}

export const ModalProductComponent: React.FC<Props> = ({ children }) => {
    const { closeModal } = useModal();
    const categories = useStore((store) => store.categories);
    const suppliers = useStore((store) => store.suppliers);
    const { openGenericDialog } = useDialog();
    const [tab, setTab] = React.useState(0);

    const {
        productComponent,
        isEdited,
        isEditable,
        setIsEditable,
        isNew,
        handleDelete,
        cancel,
        confirm,
        validationResult,
        validate,
        setCode,
        setCategories,
        setDescription,
        setPrice,
        setOldPrice,
        setDiscount,
        setMargin,
        setSupplierId,
        setPriceType,
        setPriceExpression,
        addComponent,
        setComponentIdToAdd,
        setComponentQtyToAdd,
        componentIdToAdd,
        componentQtyToAdd,
        removeComponent,
        updateComponent,
    } = useModalProductComponentContext();

    const productComponents = useStore((state) => state.productComponents);

    console.log(productComponent);

    if (!productComponent) {
        return null;
    }
    return (
        <Modal id="MODAL_PRODUCT_COMPONENT" style={{ width: "600px" }} onDismiss={() => {}}>
            <>
                <ModalHeader>
                    <div>
                        <Grid.Row xs={{ align: "center" }}>Product Component</Grid.Row>
                    </div>
                    {/* TODO: Enable this feature */}
                    {false && !isNew && !isEdited && (
                        <div onClick={() => setIsEditable(!isEditable)}>
                            <Text size="s" color="base_contrast">
                                {isEditable ? "CANCEL EDITING" : "EDIT"}
                            </Text>
                        </div>
                    )}
                </ModalHeader>
                <ModalBody>
                    <Spacer xs={[2]}>
                        <Island>
                            <Spacer xs={[1, 0]}>
                                <FormLabel>Code</FormLabel>
                                {isEditable ? (
                                    <FormInput
                                        value={productComponent.code}
                                        style={{ width: "100%" }}
                                        onChange={(e) => setCode(e.target.value)}
                                        onBlur={validate}
                                    />
                                ) : (
                                    <FormValue>{productComponent.code}</FormValue>
                                )}
                                {isEditable &&
                                    validationResult &&
                                    !validationResult.code._isValid && (
                                        <FormNotice>{validationResult.code._errors[0]}</FormNotice>
                                    )}
                            </Spacer>
                            <hr />
                            <Spacer xs={[1, 0]}>
                                <Grid.Row>
                                    <Grid.Col xs={{ cols: 4 }}>
                                        <Spacer xs={[0, 1, 1, 0]} style={{ width: "100%" }}>
                                            <FormLabel>Price</FormLabel>
                                            {isEditable ? (
                                                <FormNumber
                                                    value={productComponent.price}
                                                    placeholder="0"
                                                    style={{ width: "100%" }}
                                                    isFloat
                                                    onChange={(e) =>
                                                        setPrice(parseFloat(e.target.value))
                                                    }
                                                    onBlur={validate}
                                                />
                                            ) : (
                                                <FormValue>
                                                    {productComponent.price}&nbsp;
                                                </FormValue>
                                            )}
                                        </Spacer>
                                    </Grid.Col>
                                    <Grid.Col xs={{ cols: 4 }}>
                                        <Spacer xs={[0, 1, 1, 0]} style={{ width: "100%" }}>
                                            <FormLabel>Old Price</FormLabel>
                                            {isEditable ? (
                                                <FormNumber
                                                    value={productComponent.oldprice}
                                                    placeholder="0"
                                                    style={{ width: "100%" }}
                                                    isFloat
                                                    onChange={(e) =>
                                                        setOldPrice(parseFloat(e.target.value))
                                                    }
                                                    onBlur={validate}
                                                />
                                            ) : (
                                                <FormValue>
                                                    {productComponent.oldprice}&nbsp;
                                                </FormValue>
                                            )}
                                        </Spacer>
                                    </Grid.Col>
                                    <Grid.Col xs={{ cols: 4 }}>
                                        <Spacer xs={[0, 1, 1, 1]} style={{ width: "100%" }}>
                                            <FormLabel>Discount</FormLabel>
                                            {isEditable ? (
                                                <FormNumber
                                                    value={productComponent.discount}
                                                    placeholder="0"
                                                    isFloat
                                                    style={{ width: "100%" }}
                                                    onChange={(e) =>
                                                        setDiscount(parseFloat(e.target.value))
                                                    }
                                                    onBlur={validate}
                                                />
                                            ) : (
                                                <FormValue>
                                                    {productComponent.discount}&nbsp;
                                                </FormValue>
                                            )}
                                        </Spacer>
                                    </Grid.Col>
                                    <Grid.Col xs={{ cols: 4 }}>
                                        <Spacer xs={[0, 0, 1, 1]} style={{ width: "100%" }}>
                                            <FormLabel>Margin</FormLabel>
                                            {isEditable ? (
                                                <FormNumber
                                                    value={productComponent.margin}
                                                    placeholder="0"
                                                    isFloat
                                                    style={{ width: "100%" }}
                                                    onChange={(e) =>
                                                        setMargin(parseFloat(e.target.value))
                                                    }
                                                    onBlur={validate}
                                                />
                                            ) : (
                                                <FormValue>
                                                    {productComponent.margin}&nbsp;
                                                </FormValue>
                                            )}
                                        </Spacer>
                                    </Grid.Col>
                                </Grid.Row>
                                {(productComponent.discount || productComponent.margin) ? (<Notice color="accent4">Calculated price: £{fns.productComponent.getPrice(productComponent, productComponents)}</Notice>) : null}
                            </Spacer>
                            <hr />
                            <Spacer xs={[1, 0]}>
                                <FormLabel>Supplier</FormLabel>
                                <FormSelect
                                    options={suppliers.map((supplier) => ({
                                        label: supplier.name,
                                        value: supplier.id,
                                    }))}
                                    value={
                                        productComponent.supplierId
                                            ? {
                                                  label: suppliers.find(
                                                      (s) => s.id === productComponent.supplierId
                                                  )?.name,
                                                  value: productComponent.supplierId,
                                              }
                                            : null
                                    }
                                    onChange={(option: { label: string; value: string } | null) =>
                                        setSupplierId(option?.value || null)
                                    }
                                    isClearable
                                />
                            </Spacer>
                            <Spacer xs={[1, 0]}>
                                <FormLabel>Categories</FormLabel>
                                {isEditable ? (
                                    <FormSelect
                                        options={categories.map((category) => ({
                                            label: category.name,
                                            value: category.id,
                                        }))}
                                        value={
                                            productComponent.categories &&
                                            productComponent.categories.length > 0 &&
                                            productComponent.categories.map((id) => {
                                                const category = categories.find(
                                                    (c) => c.id === id
                                                );
                                                if (category)
                                                    return {
                                                        label: category.name,
                                                        value: category.id,
                                                    };
                                            })
                                        }
                                        isMulti={true}
                                        onChange={(options: { label: string; value: string }[]) => {
                                            setCategories(
                                                options && options.length > 0
                                                    ? options.map((option) => option.value)
                                                    : []
                                            );
                                        }}
                                    />
                                ) : (
                                    productComponent.categories &&
                                    productComponent.categories
                                        .filter((id) => categories.find((c) => c.id === id))
                                        .map((id) => {
                                            const category = categories.find((c) => c.id === id);
                                            return (
                                                <Tag type={5} size="l" key={category?.id}>
                                                    {category?.name}
                                                </Tag>
                                            );
                                        })
                                )}
                            </Spacer>
                            <Spacer xs={[1, 0]}>
                                <FormLabel>Description</FormLabel>
                                {isEditable ? (
                                    <FormTextarea
                                        value={productComponent.description}
                                        style={{ width: "100%" }}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                ) : (
                                    <FormValue>{productComponent.description}&nbsp;</FormValue>
                                )}
                            </Spacer>
                        </Island>
                        <Island>
                        <Spacer xs={[0, 0, 1, 0]}>
                        <Text size="xl">Components</Text>
                    </Spacer>
                    <Spacer xs={[1, 0]}>
                        <FormLabel>Add Component</FormLabel>
                        <Grid.Row>
                            <Grid.Col xs={{ cols: 6 }}>
                                <Spacer xs={[0, 1, 0, 0]}>
                                    <FormSelect
                                        options={productComponents
                                            .filter(
                                                (pc) =>
                                                    !productComponent.components.find(
                                                        (ppc) => ppc.id === pc.id
                                                    )
                                            )
                                            .map((component) => {
                                                return {
                                                    value: component.id,
                                                    label: component.code,
                                                };
                                            })}
                                        onChange={(option: { id: string; value: string }) => {
                                            setComponentIdToAdd(option.value);
                                        }}
                                        value={{
                                            id: componentIdToAdd,
                                            label:
                                                productComponents.find(
                                                    (pc) => pc.id === componentIdToAdd
                                                )?.code || "",
                                        }}
                                    />
                                </Spacer>
                            </Grid.Col>
                            <Grid.Col xs={{ cols: 3 }}>
                                <Spacer xs={[0, 1, 0, 0]}>
                                    <FormNumber
                                        style={{ width: "100%" }}
                                        value={componentQtyToAdd}
                                        onChange={(e) =>
                                            setComponentQtyToAdd(
                                                !isNaN(parseFloat(e.target.value))
                                                    ? parseFloat(e.target.value)
                                                    : 1
                                            )
                                        }
                                        isFloat
                                    ></FormNumber>
                                </Spacer>
                            </Grid.Col>
                            <Grid.Col xs={{ cols: 3 }}>
                                <button
                                    className="primary"
                                    style={{
                                        width: "100%",
                                        textAlign: "center",
                                    }}
                                    disabled={!componentIdToAdd || !componentQtyToAdd}
                                    onClick={addComponent}
                                >
                                    Add
                                </button>
                            </Grid.Col>
                        </Grid.Row>
                        <Spacer xs={[1, 0]}>
                            <hr />
                        </Spacer>
                        {productComponent.components.length > 0 && (
                            <>
                            <Table cols={18}>
                                <Thead>
                                    <Tr>
                                        <Th colspan={4}>Code</Th>
                                        <Th colspan={4}>Qty</Th>
                                        <Th colspan={4}>Unit Price</Th>
                                        <Th colspan={4}>Total</Th>
                                        <Th colspan={2}></Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {productComponent.components.map((component, index) => {
                                        const foundComponent = productComponents.find(
                                            (pc) => pc.id === component.id
                                        );
                                        if (!foundComponent) return null;

                                        return (
                                            <Tr key={component.id}>
                                                <Td colspan={4}>{foundComponent.code}</Td>

                                                <TdInput
                                                    colspan={4}
                                                    value={component.qty}
                                                    component={FormNumber}
                                                    isFloat
                                                    onChange={(e) => {
                                                        !isNaN(
                                                            parseFloat(
                                                                (e.target as HTMLInputElement).value
                                                            )
                                                        ) &&
                                                            updateComponent(index, {
                                                                qty: parseFloat(
                                                                    (e.target as HTMLInputElement)
                                                                        .value
                                                                ),
                                                                id: component.id,
                                                            });
                                                    }}
                                                />
                                                <Td colspan={4}>
                                                    <Ellipsis
                                                        tooltipText={String(
                                                            fns.productComponent.getPrice(
                                                                foundComponent,
                                                                productComponents
                                                            )
                                                        )}
                                                    >
                                                        {fns.productComponent.getPrice(
                                                            foundComponent,
                                                            productComponents
                                                        )}
                                                    </Ellipsis>
                                                </Td>
                                                <Td colspan={4}>
                                                    <Ellipsis
                                                        tooltipText={String(
                                                            fns.shared.getQuantityPrice(
                                                                fns.productComponent.getPrice(
                                                                    foundComponent,
                                                                    productComponents
                                                                ),
                                                                component.qty
                                                            )
                                                        )}
                                                    >
                                                        {fns.shared.getQuantityPrice(
                                                            fns.productComponent.getPrice(
                                                                foundComponent,
                                                                productComponents
                                                            ),
                                                            component.qty
                                                        )}
                                                    </Ellipsis>
                                                </Td>
                                                <Td colspan={2} align="c">
                                                    <Icon
                                                        name="delete-bin"
                                                        onClick={() => removeComponent(index)}
                                                    ></Icon>
                                                </Td>
                                            </Tr>
                                        );
                                    })}
                                </Tbody>
                            </Table>
                            <Spacer xs={[1, 0]}></Spacer>
                            <Notice color="accent1">
                            <Text size="m" color="text">Components total: <Text bold size="m" color="text">£{fns.productComponent.getSubComponentsTotal(productComponent, productComponents)}</Text></Text>
                            </Notice></>
                        )}
                    </Spacer>
                        </Island>

                        <Spacer xs={[1]}></Spacer>
                        {!isNew && isEditable && (
                            <Island>
                                <Spacer xs={[1, 0]}>
                                    <FormLabel>Delete Component</FormLabel>
                                    <button className="danger" onClick={handleDelete}>
                                        Delete
                                    </button>
                                </Spacer>
                            </Island>
                        )}
                    </Spacer>
                </ModalBody>
                <ModalFooter>
                    {(isEdited || isNew) && <button onClick={cancel}> {"Cancel"}</button>}
                    {!isEdited && !isNew && (
                        <button onClick={() => closeModal("MODAL_PRODUCT_COMPONENT")}> Ok</button>
                    )}
                    <Spacer xs={[0.5]} />
                    {isEdited && (
                        <button className="primary" onClick={confirm}>
                            Save
                        </button>
                    )}
                </ModalFooter>
            </>
        </Modal>
    );
};
